export const common = {
  //搜索类型
  searchTypeList: [
    {label : '手机号', value : 1},
    {label : '昵称', value : 2},
    {label : '用户ID', value : 3}
  ],

  //性别
  sexList: [
    {label: '不限',value: -1},
    {label: '男',value: 1},
    {label: '女',value: 2}
  ],

  //真人
  baiduMatchStateList: [
    {label: '不限', value: -1},
    {label: '未认证', value: 0},
    {label: '已认证', value: 1},
    {label: '认证失败', value: 2},
  ],

  //实名
  baiduAuthStateList: [
    {label: '不限', value: -1},
    {label: '未认证', value: 0},
    {label: '已认证', value: 1},
    {label: '认证失败', value: 2},
  ],

  //隐藏
  showStateList: [
    {label: '不限', value: -1},
    {label: '展示中', value: 0},
    {label: '已隐藏', value: 1},
  ],

  //封号
  forbiddenStateList: [
    {label: '不限', value: -1},
    {label: '未封号', value: 0},
    {label: '已封号', value: 1},
  ],

  //禁言
  bannedChatStateList: [
    {label: "不限", value: -1},
    {label: "正常", value: 0},
    {label: "已禁言", value: 1},
  ],

  //设备
  idfaBanStateList: [
    {label: "不限", value: -1},
    {label: "正常", value: 0},
    {label: "已冻结", value: 1},
  ],
  idfaBanState: -1,


}

//认证管理
export const auth = {
  //身份认证总状态
  overallAuthStateList: [
    {label: '不限制',value: -1},
    {label: '未提交',value: 0},
    {label: '待审核',value: 1},
    {label: '审核通过',value: 2},
    {label: '审核不通过',value: 3}
  ],
  //职业认证方式
  authTypeList: [
    {label:"不限",value:-1},
    {label:"其他材料",value:0},
    {label:"名片",value:1},
    {label:"在职证明",value:2},
    {label:"工牌",value:3},
    {label:"企业邮箱",value:4}
  ],

  stateList: [
    {label:"不限",value:-1},
    {label:"保存没去申请认证",value:0},
    {label:"待认证",value:1},
    {label:"已认证",value:2},
    {label:"认证失败",value:3}
  ],

  isDelList: [
    {label: '不限', value: -1},
    {label: '已失效', value: 1},
    {label: '有效', value: 0},
  ],

  //学历
  eduList: [
    {label:"不限",value:-1},
    {label:"初中",value:1},
    {label:"中专/职高/技校",value:2},
    {label:"高中/大专",value:3},
    {label:"大专",value:4},
    {label:"本科",value:5},
    {label:"硕士",value:6},
    {label:"博士",value:7},
    {label:"博士后",value:8}
  ],

  resStateList: [
    {label:"不限",value:-1},
    {label:"未查看",value:0},
    {label:"待审核",value:1},
    {label:"审核通过",value:2},
    {label:"审核不通过",value:3}
  ],

  videoStateList: [
    {label:"不限",value:-1},
    {label:"非vip",value:1},
    {label:"vip未过期",value:2},
    {label:"vip已过期",value:3},
    {label:"终身vip",value:4},
  ]

}

/**
 * 身份证审核
 */
export const identity = {
  //查询类型
  searchTypeList: [
    {label:"手机号",value:1},
    {label:"昵称",value:2},
    {label:"身份证号码",value:3},
    {label:"身份证名字",value:4},
    {label:"用户id",value:5},
    {label:"邀请码",value:6},
    {label:"用户日志",value:7}
  ],
  //状态
  stateList: [
    {label:"不限制",value:-1},
    {label:"待审核",value:1},
    {label:"未提交",value:0},
    {label:"审核通过",value:2},
    {label:"审核不通过",value:3}
  ],
  //进入情况
  enterTypeList: [
    {label:"不限制",value:-1},
    {label:"未进入",value:99},
    {label:"已进入",value:100},
    {label:"免费进入",value:0},
    {label:"邀请码进入",value:1},
    {label:"认证费用",value:2},
    {label:"保证金进入+认证费用",value:3},
    {label:"保证金+邀请码",value:4},
    {label:"直接进入",value:5},
    {label:"芝麻认证进入",value:6},
    {label:"身份证直接进入",value:7},
  ]
}
